export default __webpack_public_path__ + "static/media/saratu.4423dfbc.jpg";